module.exports = {
      id: "comm-video-usage",
      viewBox: "0 0 276.069 41.984",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-video",
      toString: function () {
        return this.url;
      }
    }